export default __webpack_public_path__ + "ee70e3a165070a55d96468302d00b187.png";